module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('city-blank-form', {
    attrs: {
      "submit-label": "Добавить город",
      "city": _vm.city,
      "errors": _vm.errors,
      "form-type": "add"
    },
    on: {
      "submit": _vm.processForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-136ccbd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/city/CityAddForm.vue
// module id = 582
// module chunks = 0